import { PENDING_LYRICS_KEY } from './storage';

export const PENDING_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

export function makePendingLyrics(guestSessionId, lyrics, now = Date.now()) {
  return { guestSessionId, lyrics, createdAt: new Date(now).toISOString() };
}

export function bindPendingLyrics(pending, userId, projectId) {
  return { ...pending, userId, projectId };
}

export function pendingLyricsAction(pending, signedInUserId, now = Date.now()) {
  if (!pending || typeof pending !== 'object') return 'none';
  const createdAt = Date.parse(pending.createdAt);
  if (!Number.isFinite(createdAt) || now - createdAt > PENDING_MAX_AGE_MS) return 'expired';
  if (pending.userId && signedInUserId && pending.userId === signedInUserId
      && pending.projectId) return 'retry';
  return 'local-only';
}

export function readPendingLyrics(storage, now = Date.now()) {
  try {
    const raw = storage.getItem(PENDING_LYRICS_KEY);
    const pending = raw ? JSON.parse(raw) : null;
    if (pendingLyricsAction(pending, null, now) === 'expired') {
      storage.removeItem(PENDING_LYRICS_KEY);
      return null;
    }
    return pending;
  } catch (error) {
    storage.removeItem(PENDING_LYRICS_KEY);
    return null;
  }
}

export function writePendingLyrics(storage, pending) {
  storage.setItem(PENDING_LYRICS_KEY, JSON.stringify(pending));
}

export function clearPendingLyrics(storage) {
  storage.removeItem(PENDING_LYRICS_KEY);
}

export async function autoSavePendingLyrics(pending, signedInUserId, save) {
  if (pendingLyricsAction(pending, signedInUserId) !== 'retry') return false;
  await save(pending.projectId, { lyrics_data: pending.lyrics });
  return true;
}
